import {Injectable} from '@angular/core';
import {LoadFamilies} from '../store/actions/custom-families.action';
import {StateWithFamilies} from '../store/custom-families-state';
import {Store} from '@ngrx/store';
import {ActivatedRoute, Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CustomFamiliesService {

  constructor(protected store: Store<StateWithFamilies>, protected router: Router, protected route: ActivatedRoute) {
  }

  loadFamilies(code: string, professional: boolean): void {
    this.store.dispatch(
      new LoadFamilies({
        code,
        professional
      }),
    );
  }
}
